import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/pages/AuthCallback";
import Home from "@/pages/Home";
import Projet from "@/pages/Projet";
import Technique from "@/pages/Technique";
import Impact from "@/pages/Impact";
import Suivi from "@/pages/Suivi";
import ContactPage from "@/pages/ContactPage";
import Espace from "@/pages/Espace";

function AppRouter() {
  const location = useLocation();
  // Process new OAuth session_id FIRST (synchronously) before any route/auth check.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/projet" element={<Projet />} />
        <Route path="/technique" element={<Technique />} />
        <Route path="/impact" element={<Impact />} />
        <Route path="/suivi" element={<Suivi />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/espace" element={<ProtectedRoute><Espace /></ProtectedRoute>} />
        <Route path="*" element={<Home />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <SmoothScroll>
              <AppRouter />
            </SmoothScroll>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
